<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre_15" id="calibre_pb_26"><span class="calibre10">THE EGO</span></h2>
<h2 class="calibre_22" id="filepos69765"><span class="calibre10"><span class="italic1">6 <img alt="image" class="calibre11" src="images/00004.jpg"/> Policemen Disguising Themselves as Thieves in Order to Catch Themselves</span></span></h2><div class="calibre_14"> </div>
<p class="calibre_18"><span class="calibre5">Of the many earnest, and how earnest, people we may observe reading, attending lectures, studying and practising disciplines, devoting their energies to the attainment of a liberation which is by definition unattainable, how many are <em class="italic">not</em> striving <em class="italic">via the ego-concept</em> which is itself the only barrier between what they think they are and that which they wish to become but always have been and always will be?</span></p>
<p class="calibre_19"><span class="calibre5">Were we to read less and understand more might we not <a></a>remember that the T’ang Masters repeatedly told us that mind cannot be reached through mind, and that there is only one mind? Perhaps less earnest people pay more attention to what they were told by those who KNEW?</span></p>
<h3 class="calibre_26" id="filepos70869"><span class="calibre12"><span class="italic1">Armchair Travelling</span></span></h3><div class="calibre_14"> </div>
<p class="calibre_19"><span class="calibre5">Knowing that no such thing as an “ego” can exist, but continuing to talk and think about “the” ego, i.e. as something still believed in, is like someone who decides to go for a journey, packs his luggage—and then never leaves home!</span></p> <div class="mbp_pagebreak" id="calibre_pb_27"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_016.vue?13bfb050